/* eslint-disable react/jsx-filename-extension */

/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews';
import 'gatsby-plugin-prismic-previews/dist/styles.css';
import './src/styles/main.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Client-side Firebase configuration using GATSBY_ prefixed variables
const firebaseConfig = {
  apiKey: process.env.GATSBY_FIREBASE_API_KEY,
  authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.GATSBY_FIREBASE_APP_ID,
  measurementId: process.env.GATSBY_FIREBASE_MEASUREMENT_ID,
};

// Validate critical fields
if (!firebaseConfig.projectId) {
  console.error('❌ CRITICAL: Firebase projectId is undefined!');
  console.error('Make sure GATSBY_FIREBASE_PROJECT_ID is set in Netlify environment variables');
}

if (!firebaseConfig.apiKey) {
  console.error('❌ CRITICAL: Firebase apiKey is undefined!');
  console.error('Make sure GATSBY_FIREBASE_API_KEY is set in Netlify environment variables');
}

const isBrowser = typeof window !== 'undefined';

if (isBrowser && !firebase.apps.length) {
  if (firebaseConfig.projectId && firebaseConfig.apiKey) {
    firebase.initializeApp(firebaseConfig);
  } else {
    console.error('❌ Cannot initialize Firebase: missing critical environment variables');
  }
} else if (isBrowser && firebase.apps.length > 0) {
  console.log('✅ Firebase already initialized');
}

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider>{element}</PrismicPreviewProvider>
);
